/// <amd-module name="Wit/WorkItemForm/Common/Services/WorkItemFormService" />
import { IObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import { FormLayout } from "Wit/Clients/Wit/Contracts/WorkItemFormLayout";
import { IWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";
import { IHistoryItem, IWorkItemFormService } from "./IWorkItemFormService";

const WorkItemFormHistoryDataProviderId = "ms.vss-work-web.work-item-form-history-data-provider";
const WorkItemTagsProviderId = "ms.vss-work-web.work-item-tag-suggestions-data-provider";

// TODO: revisit error handling and externalize error messages

class WorkItemFormService extends VssService implements IWorkItemFormService {
    private contributionService: IVssContributionService;
    public workItemHistoryPromise: IObservableValue<Promise<IHistoryItem[]> | undefined> = new ObservableValue<Promise<IHistoryItem[]> | undefined>(
        undefined
    );
    private historyPromiseWorkItemId: number;
    private workItemTagsPromise: Promise<string[]>;

    public _serviceStart(pageContext: IVssPageContext) {
        this.contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this.pageContext = pageContext;
    }

    public getWorkItemFormLayout(workItemTypeData: IWorkItemTypeData): FormLayout {
        const form = workItemTypeData.rules.form;
        if (!form) {
            throw new Error("Work item form layout not found");
        }
        const returnValue = deserializeVssJsonObject<FormLayout>(String(form)) || undefined;
        if (!returnValue) {
            throw new Error("Could not deserialize work item form layout");
        }
        return returnValue;
    }

    public resetHistoryData(): void {
        this.workItemHistoryPromise.value = undefined;
    }

    public getHistoryData(workItemId: number, projectId: string): Promise<IHistoryItem[]> {
        // Work item updates are not need for TTI, so load them asynchronously as needed;
        if (!this.workItemHistoryPromise.value || !this.historyPromiseWorkItemId || this.historyPromiseWorkItemId !== workItemId) {
            const historyProviderData = {
                Id: workItemId,
                ProjectId: projectId
            };
            this.historyPromiseWorkItemId = workItemId;
            this.workItemHistoryPromise.value = this.contributionService
                .getDataAsync<IHistoryItem[]>(WorkItemFormHistoryDataProviderId, historyProviderData, true)
                .then(data => data ?? []);
        }

        return this.workItemHistoryPromise.value;
    }

    public getTagsData(projectGuid: string): Promise<string[]> {
        if (!this.workItemTagsPromise) {
            const tagsProviderData = {
                projectScope: projectGuid
            };
            this.workItemTagsPromise = this.contributionService.getDataAsync<string[]>(WorkItemTagsProviderId, tagsProviderData, true).then(data => {
                return data || [];
            });
        }
        return this.workItemTagsPromise;
    }
}

const serviceName = "IWorkItemFormService";
Services.add(serviceName, { serviceFactory: WorkItemFormService });
